module.exports = __webpack_public_path__ + "static/media/perso.30f6438e.png";